import { c as _c } from "react/compiler-runtime";
import { DynamicallyUpdatingArea } from '@/components/Molecules/DynamicallyUpdatingArea/DynamicallyUpdatingArea';
import type { QuickSearchContentResults } from '@/contexts/GlobalSearchContext';
import { useGlobalSearchContext } from '@/contexts/GlobalSearchContext';
import useTranslation from '@/hooks/useTranslation';
import { useRef } from 'react';
import styles from './ContentResultsSection.module.css';
import { ResultGroup } from './ResultGroup';
export const ContentResultsSection = () => {
  const $ = _c(24);
  const {
    globalSearchResults,
    activeQuery,
    isLoading
  } = useGlobalSearchContext();
  const {
    t
  } = useTranslation("common");
  const ref = useRef(null);
  if (!globalSearchResults || globalSearchResults.totalResults === 0) {
    return null;
  }
  const {
    resultGroups
  } = globalSearchResults;
  const {
    research,
    news,
    data,
    event
  } = resultGroups as QuickSearchContentResults['resultGroups'];
  let t0;
  if ($[0] !== activeQuery || $[1] !== research || $[2] !== t) {
    t0 = research?.items.length > 0 && <ResultGroup analyticsBaseId="Quick Search: Research" totalCount={research.totalResults} items={research.items} title={t("Sections.research")} seeAllItemsLink={`/search?q=${activeQuery}`} asCard={true} wrapperRef={ref} />;
    $[0] = activeQuery;
    $[1] = research;
    $[2] = t;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== activeQuery || $[5] !== news || $[6] !== t) {
    t1 = news?.items.length > 0 && <ResultGroup analyticsBaseId="Quick Search: News" totalCount={news.totalResults} items={news.items} title={t("Sections.news")} seeAllItemsLink={`/search/news?q=${activeQuery}`} asCard={true} wrapperRef={ref} />;
    $[4] = activeQuery;
    $[5] = news;
    $[6] = t;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== activeQuery || $[9] !== data || $[10] !== t) {
    t2 = data?.items.length > 0 && <ResultGroup analyticsBaseId="Quick Search: Data" items={data.items} title={t("SiteSection.data")} totalCount={data.totalResults} seeAllItemsLink={`/search/data?q=${activeQuery}`} asCard={true} wrapperRef={ref} />;
    $[8] = activeQuery;
    $[9] = data;
    $[10] = t;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== activeQuery || $[13] !== event || $[14] !== t) {
    t3 = event?.items.length > 0 && <ResultGroup analyticsBaseId="Quick Search: Events & Videos" totalCount={event.totalResults} items={event.items} title={t("Sections.events_and_videos")} seeAllItemsLink={`/search/events?q=${activeQuery}`} asCard={true} wrapperRef={ref} />;
    $[12] = activeQuery;
    $[13] = event;
    $[14] = t;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== t0 || $[17] !== t1 || $[18] !== t2 || $[19] !== t3) {
    t4 = <div className={styles.styledResultsGrid}>{t0}{t1}{t2}{t3}</div>;
    $[16] = t0;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  let t5;
  if ($[21] !== isLoading || $[22] !== t4) {
    t5 = <DynamicallyUpdatingArea loading={isLoading}>{t4}</DynamicallyUpdatingArea>;
    $[21] = isLoading;
    $[22] = t4;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  return t5;
};